// extracted by mini-css-extract-plugin
module.exports = {"flexPage":"FlexPage_flexPage__3dXRg"};